module.exports = __webpack_public_path__ + "img/mobile-spectrum-ProjectSpectrum.7be03655.png";